import { render, staticRenderFns } from "./AddStage.vue?vue&type=template&id=4ebb5abc"
import script from "./AddStage.vue?vue&type=script&lang=js"
export * from "./AddStage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports